<app-loading *ngIf="loading"></app-loading>
<div class="panel-header panel-header-sm">
    <div class="row link-header ml-5">
        <div>
            <a class="a-home" routerLink="/home">Home/</a>
        </div>
        <div>
            <a class="text-info" routerLink="/purchase-view">Ver Compras</a>
        </div>
    </div>
</div>

<div class="main-content" *ngIf="isViewBeginning">
    <div class="row justify-content-end">
        <div class="col-sm-6 col-md-3 text-right">
            <button class="btn btn-success btn-sale" routerLink="/purchase-detail"
            style="width: 100%; margin-bottom: 0.2em !important;" [disabled]="isDisabled">Reporte de Detalle</button>
        </div>
        <div class="col-sm-6 col-md-3 text-right">
            <button class="btn btn-success btn-sale" routerLink="/purchase-item-report"
            style="width: 100%; margin: 0.2em !important;" [disabled]="isDisabled">Reporte de Item</button>
        </div>
    </div>
    <br>
    <!-- TABLE GET PENDIG -->
    <div class="row justify-content-center">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col-md-8">
                            <h4 class="card-title">Listado de compras</h4>
                            <h6 class="category">Puedes filtrar por cualquier campo en la caja de texto "Search records"
                            </h6>
                        </div>
                        <div class="col-md-4">
                            <button class="btn btn-success btn-sale" style="width: 100%;" (click)="downloadToExcel()"
                                [disabled]="isDisabled">
                                Descargar Excel
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="dataTables_wrapper">
                        <div class="row">
                            <div class="col-sm-12 col-md-6">
                                <div class="dataTables_length" id="datatable_length">
                                    <label>
                                        Show
                                        <select name="datatable_length" aria-controls="datatable"
                                            class="form-control form-control-sm" (change)="entriesChange($event)">
                                            <option value="10" [selected]="entries==10">10</option>
                                            <option value="25" [selected]="entries==25">25</option>
                                            <option value="50" [selected]="entries==50">50</option>
                                            <option value="-1" [selected]="entries==-1">All</option>
                                        </select>
                                        entries
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-6">
                                <div id="datatable_filter" class="dataTables_filter">
                                    <label>
                                        <input type="search" class="form-control form-control-sm"
                                            placeholder="Search records" aria-controls="datatable"
                                            (keyup)="filterTable($event)" />
                                    </label>
                                </div>
                            </div>
                        </div>
                        <ngx-datatable class="bootstrap selection-cell" [columnMode]="'force'" [headerHeight]="50"
                            [footerHeight]="50" [rowHeight]="'auto'" [limit]="entries != -1 ? entries:undefined"
                            [rows]="temp" (activate)="onActivate($event)">
                            <ngx-datatable-column name="No." prop="purchaseCode"></ngx-datatable-column>
                            <ngx-datatable-column name="Ingresado"></ngx-datatable-column>
                            <ngx-datatable-column name="Proveedor"></ngx-datatable-column>
                            <ngx-datatable-column name="No. Factura" prop="purchaseInvoice"></ngx-datatable-column>
                            <ngx-datatable-column name="Serie Fact." prop="purchaseInvoiceSeries"></ngx-datatable-column>
                            <ngx-datatable-column name="Aut. Fact." prop="purchaseInvoiceAuth"></ngx-datatable-column>
                            <ngx-datatable-column name="Monto"></ngx-datatable-column>
                            <ngx-datatable-column name="Estado"></ngx-datatable-column>
                            <ngx-datatable-column [sortable]="false" [canAutoResize]="false" [draggable]="false"
                                [resizeable]="false">
                                <ng-template ngx-datatable-header-template let-value="value"
                                    let-allRowsSelected="allRowsSelected" let-selectFn="selectFn">
                                    Acciones
                                </ng-template>
                                <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                    let-onCheckboxChangeFn="onCheckboxChangeFn">
                                    <a href="#" class="btn btn-round btn-warning btn-icon btn-sm edit"
                                        (click)="checkFunctionPDF($event)" ngbTooltip="PDF" placement="left"><i class="fas fa-sticky-note"></i>
                                    </a>
                                    <a href="#" class="btn btn-round btn-info btn-icon btn-sm edit"
                                        (click)="checkFunction($event)" ngbTooltip="Revisar" placement="left"><i class="fas fa-eye"></i>
                                    </a>
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- END TABLE PENDING-->
</div>

<div class="main-content" *ngIf="isViewPurchase">
    <div class="row justify-content-center">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header ">
                            <div class="row">
                                <div class="col-10">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <b
                                                [ngClass]="{'text-info' : purchase.purchaseStatus == 1, 'text-success' : purchase.purchaseStatus == 2, 'text-danger' : purchase.purchaseStatus == 3}">
                                                Estado: {{purchase.estado}}
                                            </b>
                                            <br><b class="card-title">Contraseña: {{purchase.purchasePassword}}</b>
                                            <br>Proveedor: {{purchase.proveedor}}
                                            <br>Importado: {{purchase.purchaseImport == 1 ? 'Si' : 'No'}}
                                        </div>
                                        <div class="col-md-3">
                                            <label>
                                                <b>Ingresado</b>
                                                <br>Fecha: {{purchase.purchaseCreatedDate | date:'dd-MM-yyyy'}}
                                                <br>Usuario: {{purchase.createdUser}}
                                            </label>
                                            <br>
                                            <label>
                                                <b>Procesado</b>
                                                <br>Fecha: {{purchase.purchaseProcessDate | date:'dd-MM-yyyy'}}
                                                <br>Usuario: {{purchase.processUser}}
                                            </label>
                                        </div>
                                        <div class="col-md-3">
                                            <label>
                                                <b>Autorizado</b>
                                                <br>Fecha: {{purchase.purchaseAuthorizedDate | date:'dd-MM-yyyy'}}
                                                <br>Usuario: {{purchase.authorizedUser}}
                                            </label>
                                            <br>
                                            <label>
                                                <b>Cancelado</b>
                                                <br>Fecha: {{purchase.purchaseCancelDate | date:'dd-MM-yyyy'}}
                                                <br>Usuario: {{purchase.cancelUser}}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2 text-right">
                                    <a class="btn btn-round btn-warning btn-icon btn-sm success btn-erp"
                                        ngbTooltip="Salir" placement="left" (click)="viewBeginning($event)"><i
                                            class="fas fa-times"></i>
                                    </a>
                                    <br>
                                    <label>No. Factura</label>
                                    <br> {{purchase.purchaseInvoice}}
                                    <span class="btn btn-block btn-round btn-file"
                                        [ngClass]="{'btn-gray' : documentUrl == '', 'btn-success' : documentUrl != ''}">
                                        <span class="fileinput-new">Documento</span>
                                        <input type="file" (click)="viewDoc($event)" matTooltip='Permissions "Disk"'/>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="table-responsive">
                                        <table class="table table-hover">
                                            <thead>
                                                <tr style="font-weight: bold;">
                                                    <td>No.</td>
                                                    <td>U. Solicitadas</td>
                                                    <td>U. Ingresadas</td>
                                                    <td>Descripción</td>
                                                    <td>F. Cad.</td>
                                                    <td>Lote</td>
                                                    <td class="text-center">P/U con IVA {{moneda}}</td>
                                                    <td class="text-center">Total {{moneda}}</td>
                                                    <td class="text-center">Impuesto {{moneda}}</td>
                                                </tr>
                                            </thead>
                                            <tbody>                                               
                                                <tr *ngFor="let detail of purchaseDetail, let i=index"
                                                    [ngClass]="{'text-danger' : detail.purchaseDetailStatus == 2}">
                                                    <td class="text-center">{{i+1}}</td>
                                                    <td class="text-center">{{detail.purchaseDetailRequestQuantity}}
                                                    </td>
                                                    <td class="text-center">{{detail.purchaseDetailRecieveQuantity}}
                                                    </td>
                                                    <td>{{detail.purchaseDetailDescription}}</td>
                                                    <td>{{detail.purchaseDueDate  == undefinde ? detail.purchaseDueDate : '-'}}</td>
                                                    <td>{{detail.purchaseDetailLot == undefinde ? detail.purchaseDetailLot : '-'}}</td>
                                                    <td class="text-right">{{detail.purchaseDetailUnitPrice |
                                                        number:'1.2-2'}}</td>
                                                    <td class="text-right">{{detail.purchaseDetailPrice |
                                                        number:'1.2-2'}}</td>
                                                    <td class="text-right" style="color: #b7b7b7;">
                                                        {{detail.purchaseDetailTax | number:'1.2-2'}}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4" style="text-align: right;">
                                    <span style="font-weight: bold; font-size: 17px; color: darkgray;">
                                        Descuento <small style="font-weight: bold; font-size: 13px;">Q</small>
                                        {{purchase.purchaseDiscount | number:'1.2-2'}}
                                    </span>
                                </div>
                                <div class="col-md-4" style="text-align: right; color: darkgray;">
                                    <span style="font-weight: bold; font-size: 17px;">
                                        Impuesto <small style="font-weight: bold; font-size: 13px;">Q</small>
                                        {{purchase.purchaseTax | number:'1.2-2'}}
                                    </span>
                                </div>
                                <div class="col-md-4" style="text-align: right;">
                                    <span style="font-weight: bold; font-size: 25px;">
                                        Total <small style="font-weight: bold; font-size: 20px;">Q</small>
                                        {{purchase.purchaseTotal | number:'1.2-2'}}
                                    </span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <textarea class="form-control" rows="12" [(ngModel)]="purchase.purchaseComment"
                                        disabled></textarea>
                                </div>
                                <div class="col-sm-12 text-right">
                                    <label class="text-danger">*Articulos en rojo fueron eliminados de la
                                        compra!</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>